// Background video control for rl-hero. The video only loads and plays on screens 750px and wider, and not
// when the visitor prefers reduced motion or has Data Saver on; otherwise the poster image shows and the
// play button starts it on request.
(function () {
  if (window.rlHeroVideoReady) return;
  window.rlHeroVideoReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const wide = window.matchMedia('(min-width: 750px)').matches;
  const autoplay = wide && !reduceMotion && !saveData;

  function setState(button, paused) {
    if (!button) return;
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
    button.classList.toggle('is-paused', paused);
  }

  function start(video) {
    const lazySources = video.querySelectorAll('source[data-src]');
    if (lazySources.length) {
      lazySources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
    }
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  }

  document.querySelectorAll('.rl-hero').forEach((hero) => {
    const video = hero.querySelector('video.rl-hero__video');
    const button = hero.querySelector('[data-rl-video-toggle]');
    if (!video) {
      if (button) button.hidden = true;
      return;
    }

    if (autoplay) {
      start(video);
      setState(button, false);
    } else {
      setState(button, true);
    }

    if (!button) return;
    button.addEventListener('click', () => {
      if (video.paused) {
        start(video);
        setState(button, false);
      } else {
        video.pause();
        setState(button, true);
      }
    });
  });
})();
